<template>
    <div class="record-all layout-sub-page">
        <div class="record-all-top" @click="clickBlank"></div>

        <div class="record-all-content ">
            <div class="record-all-list dsp-flex">
                <div id='all' class="record-al-item" @click="clickAll" v-bind:class="{'filter-cur': curFilterData.title == 'all'}">
                    <p>{{recordTotalData.length}}</p>
                    <p>全部记录</p>
                </div>
                <div id='ungroup' class="record-al-item" @click="clickFilter('ungroup', '未分组')" v-bind:class="{'filter-cur': curFilterData.title == 'ungroup'}">
                    <p>{{recordTotalData.filter(function(item){return item.groupId == 0}).length}}</p>
                    <p>未分组</p>
                </div>
                <div id='pipan' class="record-al-item" @click="clickFilter('pipan', '有批盘')" v-bind:class="{'filter-cur': curFilterData.title == 'pipan'}">
                    <p>{{recordTotalData.filter(function(item){return item.pipan != 0}).length}}</p>
                    <p>有批盘</p>
                </div>
                <div id='nunpan' class="record-al-item" @click="clickFilter('nunpan', '有论盘')" v-bind:class="{'filter-cur': curFilterData.title == 'nunpan'}">
                    <p>{{recordTotalData.filter(function(item){return item.nunpan != 0}).length}}</p>
                    <p>有论盘</p>
                </div>
                <div id='hb' class="record-al-item" @click="clickFilter('hb', '有收费')" v-bind:class="{'filter-cur': curFilterData.title == 'hb'}">
                    <p>{{recordTotalData.filter(function(item){return item.hb != 0}).length}}</p>
                    <p>有收费</p>
                </div>
            </div>
            <!-- 2. 自定义分组列表(包含各类的数量) -->
            <div class="record-all-sub-title">
                <div class="width90p">
                    <span>自定义分组</span>
                </div>
            </div>
            <div class="record-all-group-list width90p">
                <div class="record-agl-item" v-for="data in groupData" :key="data.id" v-show="data.id != 0" v-bind:id="'all-group'+data.id" @click="clickFilter('group', data)" v-bind:class="{'filter-cur': curFilterData.title == 'group'+data.id}">{{data.f_name}}({{data.group_list.length}})</div>
            </div>
        </div>

        <div class="record-all-bottom"></div>
    </div>
</template>


<script>
import { DOM, RECORD_DOM } from '../../modules/dom'
import { CONFIG } from '../../modules/config';
export default {
    name: 'AllRecord',
    components: {},
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        recordTotalData() {
            return this.$store.state.record.recordTotalData;
        },
        groupData() {
            return this.$store.state.group.groupData;
        },
        curFilterData() {
            return this.$store.state.allrecord.curFilterData;
        }
    },
    data() {
        return {
            curPath: '',
        }
    },
    mounted: function() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var topDiv, height;
                this.curPath = this.$router.history.current.path;
            // 区分组件调用来源:记录页面
            if(this.curPath.indexOf('/record') != -1) {
                topDiv = document.getElementsByClassName('record-top-part')[0];
                height = innerHeight - topDiv.clientHeight - 160;
            // 区分组件调用来源:选择记录页面
            }else if(this.curPath.indexOf('/chooserecord') != -1) {
                topDiv = document.getElementsByClassName('record-choose-bar')[0];
                height = innerHeight - topDiv.clientHeight - 160;
            }
            var blankTopDiv = document.getElementsByClassName('record-all-top')[0];
            var listDiv = document.getElementsByClassName('record-all-group-list')[0];
            
            if(topDiv && blankTopDiv) {
                blankTopDiv.style = 'height: ' + topDiv.clientHeight + 'px';
                setTimeout(() => {
                    blankTopDiv.style = 'height: ' + topDiv.clientHeight + 'px';
                    if(CONFIG.platform == 'web') {
                        blankTopDiv.style.height = '162px';
                    }
                    listDiv.style = 'height: ' + height + 'px';
                }, 0);
            }
            
            
            this.$store.state.allrecord.showAllRecord = true;
            
            // 动态设置页面的 height 和 top 值
            this.$el.style.width = window.innerWidth + 'px';
            this.$el.style.height = window.innerHeight + 'px';
            if(this.curPath.indexOf('/record') != -1) {
                DOM.setHiddenByClassName('layout-record-list');
                DOM.setHiddenByClassName('layout-letter-side-bar');
            }else if(this.curPath.indexOf('/chooserecord') != -1) {
                RECORD_DOM.resetRecordLetterSideBarStyle('chooserecord');
            }
        },
        goBack() {
            var newPath = this.curPath.replace('/all', '');
            this.$router.replace(newPath);
        },
        clickBlank() {
            console.log('clickBlank----', this.$store.state.allrecord.curFilterData)
            this.$store.state.allrecord.showAllRecord = false;
            this.goBack();
            if(this.curPath.indexOf('/record') != -1) {
                RECORD_DOM.resetRecordListContentStyle();
                if(this.$store.state.record.recordCurOrderIndex == 1) {
                    RECORD_DOM.resetRecordLetterSideBarStyle('record');
                }
            }else if(this.curPath.indexOf('/chooserecord') != -1) {
                RECORD_DOM.resetRecordLetterSideBarStyle('chooserecord');
            }
        },
        clickAll() {
            this.$store.state.allrecord.showAllRecord = false;
            this.$store.state.allrecord.curFilterData.title = 'all';
            this.$store.state.allrecord.curFilterData.text = '全部记录';
            this.$bus.emit('updateScrollToTop')
            this.goBack();

            if(this.curPath.indexOf('/record') != -1) {
                this.$store.state.record.recordCurOrderIndex = 3;
                this.$store.dispatch('record/updateRecordFilterList');
                RECORD_DOM.resetRecordListContentStyle();
                DOM.setHiddenByClassName('layout-letter-side-bar');
            }else if(this.curPath.indexOf('/chooserecord') != -1) {
                this.$store.dispatch('allrecord/resetRecordData');
                RECORD_DOM.resetRecordListContentStyle();
                RECORD_DOM.resetRecordLetterSideBarStyle('chooserecord');
            }
        },
        clickFilter(type, data) {
            this.$store.state.allrecord.showAllRecord = false;
            this.goBack();
            switch(type){
                case 'group':
                    this.$store.state.allrecord.curFilterData.title = type + data.id;
                    this.$store.state.allrecord.curFilterData.text = data.f_name;
                    break;
                default:
                    this.$store.state.allrecord.curFilterData.title = type;
                    this.$store.state.allrecord.curFilterData.text = data;
                    break;
            }
            this.$store.dispatch('allrecord/filterAllRecordList');
            this.$bus.emit('updateScrollToTop')
            if(this.curPath.indexOf('/record') != -1) {
                this.$store.state.record.recordCurOrderIndex = 1;
                RECORD_DOM.resetRecordListContentStyle();
                RECORD_DOM.resetRecordLetterSideBarStyle('record');
            }else if(this.curPath.indexOf('/chooserecord') != -1) {
                RECORD_DOM.resetRecordLetterSideBarStyle('chooserecord');
            }
        }
    }
}
</script>